
import * as React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  /** Enable hover glow effect */
  hover?: boolean;
  /** Padding size */
  padding?: 'none' | 'sm' | 'md' | 'lg';
  /** Optional click handler */
  onClick?: () => void;
}

export const Card: React.FC<CardProps> = ({
  children,
  className,
  hover = true,
  padding = 'md',
  onClick,
}) => {
  const baseClasses = [
    'rounded-2xl',
    'border border-white/10',
    'bg-[#1a1a24]',
    'transition-all duration-200',
  ];

  if (hover) {
    baseClasses.push('hover:border-cyan-400/30', 'hover:shadow-lg', 'hover:shadow-cyan-500/5');
  }

  if (onClick) {
    baseClasses.push('cursor-pointer');
  }

  const paddingClasses = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  const classes = [...baseClasses, paddingClasses[padding]];

  if (className) {
    classes.push(className);
  }

  return (
    <div
      className={classes.join(' ')}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      } : undefined}
    >
      {children}
    </div>
  );
};
